import type { FC } from 'react';

import { ArrowLeftIcon, Button } from '@motorway/mw-highway-code';

import styles from './ModalBackButton.module.scss';

interface ModalBackButtonProps {
	onClick: () => void;
}

export const ModalBackButton: FC<ModalBackButtonProps> = ({ onClick }) => {
	return (
		<div className={styles.backButton}>
			<Button
				data-thc-modal-back-button
				icon={ArrowLeftIcon}
				label="Back"
				onClick={onClick}
				showLabel={false}
				variant="tertiary"
			/>
		</div>
	);
};
